/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllPalSubmissionsResponse } from './FindAllPalSubmissionsResponse';
import {
    FindAllPalSubmissionsResponseFromJSON,
    FindAllPalSubmissionsResponseFromJSONTyped,
    FindAllPalSubmissionsResponseToJSON,
    FindAllPalSubmissionsResponseToJSONTyped,
} from './FindAllPalSubmissionsResponse';

/**
 * 
 * @export
 * @interface FindAllPalSubmissions200Response
 */
export interface FindAllPalSubmissions200Response {
    /**
     * 
     */
    data?: FindAllPalSubmissionsResponse;
}

/**
 * Check if a given object implements the FindAllPalSubmissions200Response interface.
 */
export function instanceOfFindAllPalSubmissions200Response(value: object): value is FindAllPalSubmissions200Response {
    return true;
}

export function FindAllPalSubmissions200ResponseFromJSON(json: any): FindAllPalSubmissions200Response {
    return FindAllPalSubmissions200ResponseFromJSONTyped(json, false);
}

export function FindAllPalSubmissions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPalSubmissions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllPalSubmissionsResponseFromJSON(json['data']),
    };
}

export function FindAllPalSubmissions200ResponseToJSON(json: any): FindAllPalSubmissions200Response {
    return FindAllPalSubmissions200ResponseToJSONTyped(json, false);
}

export function FindAllPalSubmissions200ResponseToJSONTyped(value?: FindAllPalSubmissions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllPalSubmissionsResponseToJSON(value['data']),
    };
}

